import "vite/modulepreload-polyfill";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initializeApp } from "@js/vue/app.js";
initializeApp();

gsap.registerPlugin(ScrollTrigger);

// Animate h1 appearance - wait for page to load then animate from initial state
window.addEventListener("load", () => {
	// Disable parallax ScrollTriggers during entrance animations
	const allTriggers = ScrollTrigger.getAll();
	allTriggers.forEach(trigger => trigger.disable());

	gsap.to(".animate-drop-in", {
		opacity: 1,
		filter: "blur(0px)",
		y: 0,
		duration: 1,
		ease: "power2.out"
	});

	gsap.to(".animate-slide-in", {
		opacity: 1,
		x: 0,
		duration: 0.8,
		ease: "power2.out",
		delay: 0.5,
		stagger: 0.1,
		onComplete: () => {
			// Re-enable ScrollTriggers after animations complete
			allTriggers.forEach(trigger => trigger.enable());
			ScrollTrigger.refresh();
		}
	});

	// scroll reveal behavior for elements that opt in with .scroll-slide-in
	document.querySelectorAll(".scroll-slide-in").forEach((el, index) => {
		gsap.to(el, {
			opacity: 1,
			x: 0,
			duration: 0.5,
			ease: "power2.out",
			scrollTrigger: {
				trigger: el,
				start: "top 95%",
				toggleActions: "play none none none",
			},
		});
	});
});

function setVh() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
}

setVh();
window.addEventListener("resize", setVh);

import jumpLinks from "@js/jump-links.js";
jumpLinks();

import { setupParallaxElements, setupParallaxElementOverflow } from "@js/parallax.js";
setupParallaxElements();
setupParallaxElementOverflow(true);

import { onResize } from "@js/throttle.js"
onResize(() => {
	setupParallaxElementOverflow();
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log("HMR")
	});
}
